import { useSelector } from 'react-redux'

import InfluencerIdentityLabels from '@components/Inbox/InfluencerIdentity/Labels'
import { useInfluencerIdentityId } from '@context/InfluencerIdentityId'
import { useCampaignIdFromRoute } from '@hooks/useCampaignIdFromRoute'
import { IApplicationState } from '@store'
import { selectCampaignBrandName } from '@store/campaigns'
import {
  selectInfluencerBrandMatchScore,
  selectIsInfluencerIdentityNew,
  selectIsInfluencerIdentityPreviouslyPurchased,
} from '@store/influencerIdentities'

export const InboxInfluencerIdentityRowLabels = () => {
  const campaignId = useCampaignIdFromRoute()
  const { contextInfluencerIdentityId } = useInfluencerIdentityId()
  const brandName = useSelector((state: IApplicationState) =>
    selectCampaignBrandName(state, campaignId),
  )
  const isNew = useSelector((state: IApplicationState) =>
    selectIsInfluencerIdentityNew(state, campaignId, contextInfluencerIdentityId),
  )
  const isPreviouslyPurchased = useSelector((state: IApplicationState) =>
    selectIsInfluencerIdentityPreviouslyPurchased(state, campaignId, contextInfluencerIdentityId),
  )
  const brandMatchScore = useSelector((state: IApplicationState) =>
    selectInfluencerBrandMatchScore(state, campaignId, contextInfluencerIdentityId),
  )

  return (
    <InfluencerIdentityLabels
      spacing={0.9375}
      brandName={brandName ?? ''}
      showNew={isNew}
      showPreviouslyPurchased={isPreviouslyPurchased}
      brandMatchScore={brandMatchScore}
      showTalentAgencyCreatorTag
    />
  )
}

export default InboxInfluencerIdentityRowLabels
